import { validateEmail, validateFirstName, validateLastName, } from '@/validate/common';
import { validatePhoneNumber } from '@/validate/profile';
import registrationValidate from '@/validate/registration';
import { isRequiredText, strMax, isNumber, isNumberWithinRange, } from '@/validate/utils';
export const validateContactContent = [
    isRequiredText('お問い合わせ内容を入力してください'),
    strMax(2000, 'お問い合わせ内容は2000文字以内で入力してください'),
];
/**
 * validation: お問い合わせ（コンサル選定のご相談）
 */
export const validateContactConsultation = {
    additionalInformation: [
        strMax(2000, '追加情報は2000文字以内で入力してください'),
    ],
    assign: registrationValidate.validateAssign,
    budget: {
        budget: (value, record) => {
            if (record.budget_type !== '1') {
                return '';
            }
            let result = '';
            [
                isRequiredText('予算の確保状況を入力してください'),
                isNumber('正の整数を入力してください'),
                isNumberWithinRange(0, 99999, '予算の確保状況は99999万円以下で入力してください'),
            ].forEach((func) => {
                if (!result) {
                    result = func(value);
                }
            });
            return result;
        },
    },
    considerations: [
        isRequiredText('検討内容を入力してください'),
        strMax(2000, '検討内容は2000文字以内で入力してください'),
    ],
    contact: {
        about_meeting_tool: [
            isRequiredText('ご希望のWeb面談ツールを入力してください'),
            strMax(2000, 'ご希望のWeb面談ツールは2000文字以内で入力してください'),
        ],
        contactable_time_1: [
            isRequiredText('第一希望を入力してください'),
            strMax(255, '第一希望は255文字以内で入力してください'),
        ],
        contactable_time_2: [
            strMax(255, '第二希望は255文字以内で入力してください'),
        ],
        contactable_time_3: [
            strMax(255, '第三希望は255文字以内で入力してください'),
        ],
    },
    email: validateEmail,
    name: {
        first_name: validateFirstName,
        last_name: validateLastName,
    },
    phone: {
        phone1: validatePhoneNumber,
        phone2: validatePhoneNumber,
        phone3: validatePhoneNumber,
    },
    whatRequest: [
        isRequiredText('依頼内容を入力してください'),
        strMax(2000, '依頼内容は2000文字以内で入力してください'),
    ],
};
export default validateContactContent;
